import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  setOverReportCreateActions,
  setthesendEmailActions,
  setthesendEmailGetListActions,
} from "../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";
import Switch from "@mui/material/Switch";
import $ from "jquery";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";


const OverAllCreatePopup = () => {
  const Swal = require("sweetalert2");
  const today = new Date();

  var it = convert(today);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  // console.log(it, "q083it");
  const initialState = {
    api_type: "",
    recharged_amount: "",
    recharged_date: "",
    GST_amount: "",
  };
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();

  const [data, setDatas] = useState(initialState);
  const [apitypeerr, setapitypeerr] = useState("");
  const [rechargeErr, setrechargeerr] = useState("");
  const [rechargeDateErr, setRechargeErr] = useState("");
  const [typeOfval, setTypeOfVal] = useState();
  const dispatch = useDispatch();
  const API_TYPES = [
    { value: "0", label: "ZOHO" },
    { value: "1", label: "ARYA" },
    { value: "2", label: "INVINCIBLE" },
    { value: "3", label: "SANDBOX" },
    { value: "4", label: "GUPSHUP" },
  ];

  const handleTYpeOfApi = (e) => {
    setTypeOfVal(e);
    setDatas({
      ...data,
      api_type: e.value,
    });
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [date, setDate] = useState(null);
  const state = useSelector((state) => state);
  const [price, setPrice] = useState(0);
  const [gstRate, setGstRate] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const gstRates = [
    { value: 0, label: "0%" },
    // { value: 3, label: "3%" },
    { value: 5, label: "5%" },
    // { value: 8, label: "8%" },
    // { value: 12, label: "12%" },
    { value: 18, label: "18%" },
    { value: 28, label: "28%" },
  ]; // List of GST rates as objects for react-select
  /// Email---Part
  const [emailTags, setEmailTags] = useState({ tags: [] });
  const [emailTagstwo, setEmailTagstwo] = useState({ tags: [] });
  const [emailTagsthree, setEmailTagsthree] = useState({ tags: [] });

  const [emailError, setEmailError] = useState("");
  const [emailError2, setEmailError2] = useState("");

  const [emailError3, setEmailError3] = useState("");

  const [countOne, setcount1] = useState("");
  const [count2, setcount2] = useState("");

  const [count3, setcount3] = useState("");
  const CountState = {
    countsone: "",
    countstwo: "",
    countsthree: "",
  };
  const [counts, setCounts] = useState(CountState);
   const [Validations ,setValidation] = useState(0)

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [Levelone, setlevelone] = useState(false);
  const [Leveltwo, setleveltwo] = useState(false);
  const [Levelthree, setlevelthree] = useState(false);

  useEffect(() => {
    dispatch(setthesendEmailGetListActions());
  }, [state.sendEmailREportEditData.sendEmailreportDataEdit]);


  useEffect(() => {
    if (
      state.sendEmailREportgetData.sendEmailreportGetList != null &&
      state.sendEmailREportgetData.sendEmailreportGetList != undefined &&
      state.sendEmailREportgetData.sendEmailreportGetList.cost_receiver_mail !=
        null &&
      state.sendEmailREportgetData.sendEmailreportGetList.cost_receiver_mail !=
        undefined
    ) {
      Object.keys(
        state.sendEmailREportgetData.sendEmailreportGetList.cost_receiver_mail
      ).map((item) => {
        const costrece =
          state.sendEmailREportgetData.sendEmailreportGetList
            .cost_receiver_mail[item];
      });

      const mappedData = Object.keys(
        state.sendEmailREportgetData.sendEmailreportGetList.cost_receiver_mail
      ).map((key) => {
        const item =
          state.sendEmailREportgetData.sendEmailreportGetList
            .cost_receiver_mail[key];
        return {
          id: key,
          send: item.send,
          count: item.count,
          email: item.email,
        };
      });

      console.log(mappedData, "mappedData", mappedData[0]);
      if (
        mappedData.length > 0 &&
        mappedData.length == 3 &&
        mappedData[0] &&
        mappedData[1] &&
        mappedData[2]
      ) {
        setCounts({
          ...counts,
          countsone: mappedData[0].count,
          countstwo: mappedData[1].count,
          countsthree: mappedData[2].count,
        });

        setlevelone(mappedData[0].send);
        setleveltwo(mappedData[1].send);

        setlevelthree(mappedData[2].send);
// console.log(mappedData[0], "emilapwoeup"); 
 const FirstEmail = []
 const secondemail = [];
 const thrirdEmail =[];
mappedData[0].email.map((item)=>{
  FirstEmail.push(item)
   
})

mappedData[1].email.map((item)=>{
  secondemail.push(item)
   
})
mappedData[2].email.map((item)=>{
  thrirdEmail.push(item)
   
})
//  console.log(FirstEmail , secondemail ,thrirdEmail , "thrirdEmail8732109"  );

        setEmailTags({ tags: FirstEmail });
        setEmailTagstwo({ tags: secondemail });

        setEmailTagsthree({ tags: thrirdEmail });
      }
    }
  }, [state.sendEmailREportgetData.sendEmailreportGetList , state.sendEmailREportEditData.sendEmailreportDataEdit]);

  const onChange = (value) => {
    const priceBeforeGST = parseFloat(value) || 0; // Handle NaN case
    const gstAmount = priceBeforeGST * (gstRate / 100);
    const totalPrice = priceBeforeGST + gstAmount;

    setPrice(priceBeforeGST);
    setGstAmount(gstAmount);
    setTotalPrice(totalPrice);

    setDatas({
      ...data,
      recharged_amount: value,
    });
  };

  const handleGstRateChange = (selectedOption) => {
    const selectedRate = selectedOption.value;
    setGstRate(selectedRate);

    // Recalculate GST amount and total price based on the new GST rate
    const gstAmount = price * (selectedRate / 100);
    const totalPrice = price + gstAmount;

    setGstAmount(gstAmount);
    setTotalPrice(totalPrice);

    setDatas({
      ...data,
      GST_amount: gstAmount.toFixed(2),
    });
  };

  const handleDate = (inputDate, name) => {
    const value = formatDate(inputDate);
    setDatas({
      ...data,
      recharged_date: value,
    });
  };


 
  $(document).ready(function() {
    $('.react-tagsinput-input').attr('placeholder', 'Enter Email ID');
  });


  

  const HandleUpdates = (e) => {
    const { name, value } = e.target;
    setCounts({
      ...counts,
      [name]: value,
    });
  };
console.log(Validations , "Validations");
  const HandleSubmit = (e) => {
    console.log(data, "39740237data");
    var a = 0;
    if (data.api_type == "") {
      a = 1;
      setapitypeerr("*Type is required");
    }
    if (data.recharged_amount == "") {
      a = 1;
      setrechargeerr("*Recharged Amount is required");
    }
    if (data.recharged_date == "") {
      a = 1;
      setRechargeErr("*Recharged Date is required");
    }

    if (a == 0 ) {
      Swal.fire({
        title: "Once the balance is added, it cannot be edited ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes, Submit it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            data: {
              api_type: data.api_type,
              recharged_amount: Number(data.recharged_amount),
              recharged_date: data.recharged_date,
              GST_amount: Number(data.GST_amount),
            },
          };
          dispatch(setOverReportCreateActions(payload));
          navigate("/validation");

          // setDatas(initialState);
          // setTypeOfVal({});
          // setDate(null);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }

    // setDatas(initialState);
    // setTypeOfVal({});
    // setDate(null);
  };

  const sendEmail = {
    cost_receiver_mail: {
      1: {
        email:emailTags.tags,
        send: Levelone,
        count: Number(counts.countsone),
      },
      2: {
        email: emailTagstwo.tags,
        send: Leveltwo,
        count: Number(counts.countstwo),
      },
      3: {
        email: emailTagsthree.tags,
        send: Levelthree,
        count: Number(counts.countsthree),
      },
    },
  };

  const handleSendEmail = (e) => {
    var a = 0;

    if (emailTags.tags.length == 0) {
      setEmailError("*Email is required");
      a = 1;
    }

    if (emailTagstwo.tags.length == 0) {
      setEmailError2("*Email is required");
      a = 1;
    }

    if (emailTagsthree.tags.length == 0) {
      setEmailError3("*Email is required");
      a = 1;
    }

    if (counts.countsone == "") {
      setcount1("*Count is required");
      a = 1;
    }

    if (counts.countstwo == "") {
      setcount2("*Count is required");
      a = 1;
    }

    if (counts.countsthree == "") {
      setcount3("*Count is required");
      a = 1;
    }

    if (a == 0 && Validations == 0)  {
      const payloads = {
        sendEmail: sendEmail,
        // id: "ded45b18-3f12-4090-90e9-49e47cddb2c0",
        id: state.sendEmailREportgetData.sendEmailreportGetList.id,
      };
      dispatch(setthesendEmailActions(payloads));
      setCounts(CountState);
      setlevelone(false);
      setleveltwo(false);
      setlevelthree(false);
      setapitypeerr("");
      setrechargeerr("");
      setRechargeErr("");
      setEmailError("");
      setEmailError2("");
      setcount2("");
      setEmailError3("");
      setcount3("");
      setEmailTags({
        tags: [],
      });

      setEmailTagstwo({
        tags: [],
      });

      setEmailTagsthree({
        tags: [],
      });
    }
  };


  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateTags = (tags) => {
    const uniqueTags = new Set();
    for (const tag of tags) {
      if (!emailRegex.test(tag)) {
        return "One or more email addresses are invalid.";
      }
      if (uniqueTags.has(tag)) {
        return "Duplicate email addresses are not allowed.";
      }
      uniqueTags.add(tag);
    }
    return "";
  };


  return (
    <>
      <div
        className={stateDisplay ? "outterContent" : "inner-Content"}
        style={{ padding: "40px" }}
      >
        <div className="BeforePopUp OverAllReport">
          <div className="RolePopups">
            <div className="asds">
              <div class="ModalHeader">
                <h4 className="UserCreate" style={{ fontWeight: "900" }}>
                  Report
                </h4>
              </div>

              <div
                className="row Filters ButtonPrevious"
                style={{ marginLeft: "-17px" }}
              >
                <div className="col" style={{ margin: "12px 0px" }}>
                  <button
                    className="btn BackImga"
                    onClick={(e) => {
                      navigate("/validation");
                    }}
                  >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
                  </button>
                </div>
              </div>

              <form class="row g-3  Filters form-fields-wrapper">
                <div class="col-sm-2 field-div ReportFiled">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Type <span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    options={API_TYPES}
                    value={typeOfval}
                    onChange={(e) => {
                      handleTYpeOfApi(e);
                      setapitypeerr("");
                    }}
                     className="FormalFiledReport"
                  />

                  <small style={{ color: "red", marginTop: "10px" }}>
                    {apitypeerr}
                  </small>
                </div>

                <div class="col-sm-2 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                     Recharged Amount
                     <span style={{ color: "red" }}>*</span>
                  </label>

                  <NumericFormat
                    thousandSeparator={true}
                    onValueChange={(values) => {
                      const { value } = values;
                      onChange(value);
                      setrechargeerr("");
                    }}
                    isNumericString
                    displayType={"input"}
                    fixedDecimalScale={true}
                    className="form-control FormalFiledReport"
                    //  style={{height:"45%"}}
                  />

                  <small style={{ color: "red", marginTop: "10px" }}>
                    {rechargeErr}
                  </small>
                </div>

                {/* <div class="col-sm-2  field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    GST
                  </label>
                  <NumericFormat
                    className="form-control"
                    decimalScale={2}
                    fixedDecimalScale={true}
                    onValueChange={(values) => {
                      const { value } = values;
                      onChangeGST(value);
                    }}
                    isNumericString
                    displayType={"input"}
                  />
                </div> */}
                {/* <div className="col-sm-2 field-div">
        <label
          htmlFor="validationCustom01"
          className="form-label"
          style={{ fontSize: "15px" }}
        >
          Recharge Amount
        </label>
        <NumericFormat
          className="form-control"
          decimalScale={2}
          fixedDecimalScale={true}
          onValueChange={(values) => {
            const { value } = values;
            onChangeGST(value);
          }}
          isNumericString
          displayType={"input"}
        />
      </div> */}
                <div className="col-sm-2 field-div ReportFiled">
                  <label
                    htmlFor="gstRate"
                    className="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    GST Rate
                  </label>
                  <Select
                    id="gstRate"
                    value={gstRates.find((option) => option.value === gstRate)}
                    onChange={handleGstRateChange}
                    options={gstRates}
                  />
                </div>
                {/* <div>
        <p>Price Before GST: {price.toFixed(2)}</p>
        <p>GST Amount ({gstRate}%): {gstAmount.toFixed(2)}</p>
        <p>Total Price Including GST: {totalPrice.toFixed(2)}</p>

        
      </div> */}
                <div className="col-sm-2 field-div">
                  <label
                    htmlFor="gstAmount"
                    className="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    GST Amount
                  </label>
                  <NumericFormat
                    value={gstAmount.toFixed(2)}
                    className="form-control FormalFiledReport"
                    decimalScale={2}
                    fixedDecimalScale={true}
                    isNumericString
                    // displayType={"input"}
                    // style={{height:"30%"}}

                  />
                </div>

                <div class="col-sm-2  field-div">
                  <label
                    for="validationCustom01"
                    class="form-label  MaterialUICal"
                    style={{ fontSize: "15px", width: "100%" }}
                  >
                     Recharged Date
                     <span style={{ color: "red" }}>*</span>
                  </label>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        setDate(e);
                        handleDate(e?.$d, "from_date");
                        setRechargeErr("");
                      }}
                      value={date}
                      disableFuture
                      //  className="FormalFiled"
                    />
                  </LocalizationProvider>

                  <small style={{ color: "red" }}>
                    {rechargeDateErr}
                  </small>
                </div>
              </form>

              <div
                className="row"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                   marginTop:"20px"
                }}
              >
                <div className="col-sm-2"></div>
                <div className="col-sm-2"></div>
                <div
                  className="col-sm-4"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    class="btn  SaveBtn"
                    type="submit"
                    onClick={(e) => {
                      HandleSubmit(e);
                    }}
                    style={{ background: "#EF5338", color: "#fff" }}
                  >
                    Submit
                  </button>
                </div>
              </div>

<div className="col-12 Divider">

</div>
              <div className=" row Filters">
                <div className="col-12">
                  <h3>Level one</h3>
                </div>

                <div className="col-sm-6 mt-4">
                  <label for="validationCustom01" class="form-label">
                    Email Id
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <TagsInput
                    value={emailTags.tags}
                    onChange={(e) => {
                      // if (e.length <= 5) {
                      //   setEmailTags({ ...emailTags, tags: e });
                      //   setEmailError("");
                      // }


                      if (e.length <= 5) {
                        const error = validateTags(e);
                        if (error) {
                          setEmailError(error);
                        } else {
                          setEmailTags({ ...emailTags, tags: e });
                          setEmailError(""); // Clear error message if valid
                        }
                      } else {
                        setEmailError("*You cannot add more than 5 emails.");
                      }

                    }}
                    placeHolder="Enter Email I'd"
                  />









                  <small className="Error"> {emailError}</small>

                  {/* <p className="Error"> {emailError} </p> */}
                </div>
                <div className="col-sm-2 mt-4">
                  <label for="validationCustom01" class="form-label">
                    Count
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <input
                    type="number"
                    class="form-control CountField"
                    id="validationCustom01"
                    autocomplete="off"
                    name="countsone"
                    value={counts.countsone}
                    onChange={(e) => {
                      HandleUpdates(e);
                      setcount1("");
                    }}
                    
                  />
                  <small className="Error"> {countOne}</small>
                </div>

                <div className="col-sm-2 mt-4 ">
                  <label class="form-label" style={{width:"100%"}}> 

                  Turn {Levelone ? "Off" :"On"} Email ?


                  </label>
                  <Switch
                    {...label}
                    defaultChecked
                    checked={Levelone}
                    onChange={(e) => {
                      setlevelone(!Levelone);
                    }}
                    value={Levelone}
                  />
                </div>
              </div>

              <div className="row Filters mt-3">
                <div className="col-12">
                  <h3>Level two</h3>
                </div>

                <div className="col-sm-6 mt-4">
                  <label for="validationCustom01" class="form-label">
                  Email Id
                  <span style={{ color: "red" }}>*</span>

                  </label>

                  <TagsInput
                    value={emailTagstwo.tags}
                    onChange={(e) => {
                      // if (e.length <= 5) {
                      //   setEmailTagstwo({ ...emailTagstwo, tags: e });
                      //   setEmailError2("");
                      // }

                    
                      if (e.length <= 5) {
                        const error = validateTags(e);
                        if (error) {
                          setEmailError2(error);
                        } else {
                          setEmailTagstwo({ ...emailTagstwo, tags: e });

                          // setEmailTagstwo({ tags }); // Update the state with the valid tags
                          setEmailError2(""); // Clear error message if valid
                        }
                      } else {
                        setEmailError2("*You cannot add more than 5 emails.");
                      }
                  

                    }}
                    placeHolder="Enter Email I'd"
                  />
                  <small className="Error"> {emailError2}</small>

                  {/* <p className="Error"> {emailError} </p> */}
                </div>
                <div className="col-sm-2 mt-4">
                  <label for="validationCustom01" class="form-label">
                    Count
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <input
                    type="number"
                    class="form-control CountField"
                    id="validationCustom01"
                    autocomplete="off"
                    name="countstwo"
                    value={counts.countstwo}
                    onChange={(e) => {
                      //  if(Number(counts.countstwo) > Number(counts.countsone)){ 
                      //   setcount2("It greaterthen Level One Count ");

                      //  }
                      //  else if(Number(counts.countstwo) < Number(counts.countsone)){ 
                      //   setcount2("");
                      //   HandleUpdates(e);

                      //  }


                      HandleUpdates(e);


                      if (Number(e.target.value) > Number(counts.countsone)) {
                        setcount2("*Leave two count should not be greater than Level One Count.");
                        setValidation(1)
                      } 
                      

                      else {
                        setcount2("");
                        setValidation(0)

                      }

                      
            

                       
                    }}
                  />
                  <small className="Error"> {count2} </small>
                </div>

                <div className="col-sm-2 mt-4 ">
                  <label class="form-label"  style={{width:"100%"}}> 
                  Turn {Leveltwo ? "Off" :"On"} Email ?

                     </label>
                  <Switch
                    {...label}
                    defaultChecked
                    checked={Leveltwo}
                    onChange={(e) => {
                      setleveltwo(!Leveltwo);
                    }}
                    value={Leveltwo}
                  />
                </div>
              </div>

              <div className="row  Filters mt-3">
                <div className="col-12">
                  <h3>Level three</h3>
                </div>

                <div className="col-sm-6 mt-4">
                  <label for="validationCustom01" class="form-label">
                  Email Id
                  <span style={{ color: "red" }}>*</span>

                                    </label>

                  <TagsInput
                    value={emailTagsthree.tags}
                    onChange={(e) => {
                      // if (e.length <= 5) {
                      //   setEmailTagsthree({ ...emailTagsthree, tags: e });
                      //   setEmailError3("");
                      // }

                      if (e.length <= 5) {
                        const error = validateTags(e);
                        if (error) {
                          setEmailError3(error);
                        } else {
                          setEmailTagsthree({  ...emailTagsthree, tags: e }); // Update state with valid tags
                          setEmailError3(""); // Clear error message if valid
                        }
                      } else {
                        setEmailError3("*You cannot add more than 5 emails.");
                      }
                  

                    }}
                    placeHolder="Enter Email I'd"
                  />

                  <small className="Error"> {emailError3} </small>
                </div>
                <div className="col-sm-2 mt-4">
                  <label for="validationCustom01" class="form-label">
                    Count
                    <span style={{ color: "red" }}>*</span>

                  </label>

                  <input
                    type="number"
                    class="form-control CountField"
                    id="validationCustom01"
                    autocomplete="off"
                    name="countsthree"
                    value={counts.countsthree}
                    onChange={(e) => {
                      HandleUpdates(e);
                      // setcount3("");


                      if (Number(e.target.value) > Number(counts.countstwo)) {
                        setcount3("*Level three Count should not be greater than Level Two Count.");
                        setValidation(1)
                      } 
                      

                      else {
                        setcount3("");
                        setValidation(0)

                      }

                    }}
                  />
                  <small className="Error"> {count3} </small>
                </div>

                <div className="col-sm-2 mt-4 ">
                  <label class="form-label" style={{width:"100%"}}> 
                    
                  Turn {Levelthree ? "Off" :"On"} Email ?

                     </label>
                  <Switch
                    {...label}
                    defaultChecked
                    checked={Levelthree}
                    onChange={(e) => {
                      setlevelthree(!Levelthree);
                    }}
                    value={Levelthree}
                  />
                </div>
              </div>

              <div className="row Filters mt-3">



                <div className="col-9" style={{ textAlign: "right" }}>

                </div>
                <div className="col">


                <button
                    className="btn ButtonCSS"
                    style={{ background: "#F05939" , marginRight:"20px" }}
                    onClick={(e) => {
                      
                      setCounts(CountState);
                      setlevelone(false);
                      setleveltwo(false);
                      setlevelthree(false);
                
                      setEmailTags({
                        tags: [],
                      });
                
                      setEmailTagstwo({
                        tags: [],
                      });
                
                      setEmailTagsthree({
                        tags: [],
                      });
                    }}
                  >
                    Clear
                  </button>
                  
                  <button
                    className="btn ButtonCSS"
                    style={{ background: "#F05939" }}
                    onClick={(e) => {
                      handleSendEmail(e);
                    }}
                  >
                    Submit
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverAllCreatePopup;
